import React, { createContext, useEffect, useState, useCallback } from 'react';
import { LoadingIcon } from '../svg';
import * as contentful from 'contentful';
import { useBrandDetails } from 'dw-au-react-components';

export const FaqContext = createContext();

export const FaqProvider = ({ children }) => {
	const [faqData, setFaqData] = useState(null);
	const [allQuestions, setAllQuestions] = useState(null);
	const [privacyAndTerms, setPrivacyAndTerms] = useState(null);
	const brandData = useBrandDetails();

	const replaceWithBrand = useCallback(
		(string) => {
			if (string.indexOf('{brandName}') > -1) {
				string = string.replace(new RegExp('{brandName}', 'g'), brandData.name);
			}

			if (string.indexOf('{brandPhone}') > -1) {
				string = string.replace(
					new RegExp('{brandPhone}', 'g'),
					brandData.phone
				);
			}

			return string;
		},
		[brandData.name, brandData.phone]
	);

	const apiConfig = {
		customerService: {
			url: 'https://cdn.contentful.com/spaces/759ah7skns84/entries',
			method: 'GET',
			async: false,
			headers: {
				'Content-Type': 'application/json'
			},
			data: {},
			params: {
				space: '759ah7skns84',
				access_token: 'xYnUnlTFJ_jR4HayH_3GydjYLml3QREEBvki4HxGB3Y',
				content_type: 'customerService',
				include: 2,
				'fields.itemCode': ''
			}
		}
	};

	const getFaqData = useCallback(() => {
		let questionsByCategory = [];
		let getAllQuestions = [];
		let totalCount = 0;

		const request = apiConfig.customerService;
		const params = request.params;

		const client = contentful.createClient({
			space: params.space,
			accessToken: params.access_token
		});

		//Entry Id for APAC Customer Service - 18nKg1aotJpdKQqHtn1z2a
		client
			.getEntry('18nKg1aotJpdKQqHtn1z2a', { include: 3 })
			.then((entries) => {
				entries.fields.categories
					.filter((category) => {
						return (
							category.fields.market !== 'au-vws-only' &&
							category.fields.market !== 'tw-law-only'
						);
					})
					.map((entry) => {
						let questionArray = [];
						let categoryFields = entry.fields;
						let categoryMarket = categoryFields.market;
						let categorySlug = categoryFields.slug;
						let categoryTitle = categoryFields.title;

						categoryFields.questions.map((question) => {
							let questionFields = question.fields;
							let questionTitle = replaceWithBrand(questionFields.title);
							let questionAnswer = replaceWithBrand(questionFields.answer);
							let questionSlug = questionFields.slug;
							let questionMarket = questionFields.market;

							let questionObj = {
								slug: questionSlug,
								title: questionTitle,
								answer: questionAnswer,
								market: questionMarket,
								categorySlug,
								index: totalCount++
							};

							questionArray.push(questionObj);
							getAllQuestions.push(questionObj);
						});
						questionsByCategory.push({
							slug: categorySlug,
							title: categoryTitle,
							market: categoryMarket,
							questions: questionArray
						});
					});
				setAllQuestions(getAllQuestions);
				setFaqData(questionsByCategory);
			});
	}, [apiConfig.customerService, replaceWithBrand]);

	const getPrivacyAndTerms = useCallback(() => {
		const request = apiConfig.customerService;
		const params = {
			content_type: 'privacyAndTerms'
		};
		params['include'] = 2;

		const client = contentful.createClient({
			space: request.params.space,
			accessToken: request.params.access_token
		});

		client.getEntries(params).then((entries) => {
			let items = entries.items;
			const filteredData = items
				.filter((entry) => {
					return entry.fields.brand === brandData.tag;
				})
				.map((entry) => {
					let entryObject = {
						slug: entry.fields.slug,
						title: entry.fields.title,
						content: entry.fields.content,
						brand: entry.fields.brand,
						order: entry.fields.order
					};
					return entryObject;
				});
			setPrivacyAndTerms(filteredData);
		});
	}, [apiConfig.customerService, brandData.tag]);

	useEffect(() => {
		getPrivacyAndTerms();
		getFaqData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<FaqContext.Provider value={{ faqData, allQuestions, privacyAndTerms }}>
			{faqData && privacyAndTerms ? (
				children
			) : (
				<div
					className='d-flex justify-content-center align-items-center'
					style={{ minHeight: '200px' }}
				>
					<LoadingIcon />
				</div>
			)}
		</FaqContext.Provider>
	);
};
